import axios from 'axios';
export const instance = axios.create({
    baseURL: '.',
    headers: { 'Access-Control-Allow-Origin': '*' },
});
export const api = {
    get: function apiGet(url) {
        return instance.get(url);
    },
    post: function apiPost(url, data) {
        return instance.post(url, data);
    },
};
export default api;
